<template>
  <!-- swiper -->
  <swiper :options="swiperOption" ref="dom_swiper" @slideChangeTransitionEnd="slideChangeTransitionEnd">
    <swiper-slide v-for="(src, i) in src_list" :key="i" @click.native="$emit('click_swiper_slide')" :class="{'flex-justify-content-center':$img_type(src).h /$img_type(src).w < screen_ratio || $img_type(src).h < screen_height}">
      <img
        :data-src="src"
        class="swiper-lazy"
        v-no-copy="{on: can_copy_pic}"
        :style="{top: top != '' ? top : ($img_type(src).is_swiper_top ? '0' : '')}"
      />
      <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
    </swiper-slide>
    <swiper-slide v-if="src" @click="$emit('click')" @click.native="$emit('click_swiper_slide')" :class="{'flex-justify-content-center':$img_type(src).h / $img_type(src).w < screen_ratio  || $img_type(src).h < screen_height}">
      <img
        :data-src="src"
        v-no-copy="{on: can_copy_pic}"
        class="swiper-lazy"
        :style="{top: top != '' ? top : ($img_type(src).is_swiper_top ? '0' : '')}"
      />
      <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
    </swiper-slide>
    <template v-if="src_list.length > 1 && browser_size != 'small'">
      <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
      <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
    </template>
    <!-- <div v-if="src_list.length > 1" class="swiper-pagination" slot="pagination"></div> -->
    <!-- <i class="afd afd-x" slot="pagination" @click="$emit('click_swiper_slide')"></i> -->
    <div v-if="src_list.length > 1" class="page-box" slot="pagination">
      <div class="flex-box flex-a-center white lh1 page-show" @click="open">
        <span class="fs12">{{activeIndex}} / {{src_list.length}}</span>
        <i class="afd afd-arrow-down fs16 ml4"></i>
      </div>
      <div v-show="is_open_list" class="page-list">
        <a class="item flex-center flex-box fs12" v-for="(item, i) in src_list.length" :key="i" @click="page_to(item)">{{item}}</a>
      </div>
    </div> 
  </swiper>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    src_list: {
      default() {
        return [];
      }
    },
    src: {
      default() {
        return "";
      }
    },
    swiper_config: {
      default() {
        return {};
      }
    },
    top: {
      default() {
        return "";
      }
    },
    can_copy_pic:{
      default() {
        return true;
      }
    }
  },
  computed: {
    ...mapState("app", ["browser_size"]),
    // flex-justify-content-center
    screen_ratio(){
      return window.innerHeight / window.innerWidth
    },
    screen_height(){
      return window.innerHeight
    },
    swiper() {
      return this.$refs.dom_swiper.swiper
    },
  },
  data() {
    let initialSlide = this.swiper_config.initialSlide || 0;
    let activeIndex = initialSlide + 1;
    return {
      is_open_list:false,
      activeIndex,
      swiperOption: {
        // Enable lazy loading
        initialSlide,
        lazy: true,
        zoom: true,
        zoomToggle :false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  mounted() {
    this.mixin_lock_scroll();
  },
  beforeDestroy() {
    this.mixin_unlock_scroll();
  },
  methods: {
    page_to(n){
      this.is_open_list = false;
      this.swiper.slideTo(n - 1, 300, false)
      this.activeIndex = n
    },
    open(){
      this.is_open_list = !this.is_open_list;
    },
    slideChangeTransitionEnd(){
      this.activeIndex = this.swiper.activeIndex + 1
    }
  }
};
</script>

<style lang="stylus" scoped>
.swiper-container {
  width: 100%;
  min-height: 100vh;
}

.swiper-slide {
  text-align: center;
  /* font-size: 18px; */
  /* background: #444!important; */
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  position: relative;
}

.swiper-slide {
  img {
    width: auto;
    height: auto;
    max-width: 100%;
    // max-height: 100%
    // transform: translate(-50%, -50%);
    position: absolute;
    /* top 0 */
  }
}

.swiper-button-next, .swiper-button-prev {
  z-index: 1;
  // width px2rem(150)
  padding: 0 px2rem(20) 0 px2rem(100);
  background-color: transparent;
  /* background-image none */
  top: 0;
  cursor: e-resize;
  height: 100vh;
  right: 0;
  position: fixed;
}

.swiper-button-prev {
  left: 0;
  padding: 0 px2rem(100) 0 px2rem(20);
  cursor: w-resize;
}

.afd-x {
  position: fixed;
  top: 30px;
  right: 30px;
  font-size: 24px;
  font-weight: bold;
  color: $white-6;
  z-index: 11;
  padding: 5px;
  background: rgba(0, 0, 0, 0.2);
}
.page-box{
  position:fixed;
  top: 16px;
  right: 16px;
  z-index: 11;
  cursor:pointer;
}
.page-show{
  background:$black-1;
  padding:8px 10px;
  border-radius: 4px;
}
.page-list{
  position: absolute;
  background:$white;
  box-shadow: $layer-shadow;
  border-radius: 4px;
  cursor:pointer;
  max-height:378px;
  overflow-y:auto;
  right: 0;
  top:40px;
  .item{
    height:42px;
    width:100px;
    box-sizing:border-box;
    &:active{
      background:$black-1;
    }
  }
}
</style>
